// components/CustomVerticalSteps.js
import React from "react";
import { Steps } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import "../../../assets/styles/InterbankPlacement.css";

/**
 * steps               // 👉 An array of step objects, each with a `title`. You can add more fields if needed (like description, key, etc.)
 * completedSteps // 👉 An array of indexes representing the steps the user has already completed.
 * current           // 👉 The index of the current step the user is on. Used to highlight the active step.
 *
 *
 */

const StepsComponent = ({ steps, current, completedSteps }) => {
  const getStatus = (index) => {
    if (completedSteps.includes(index)) return "finish";
    if (current === index) return "process";
    return "wait";
  };

  const getIcon = (index) => {
    const isCompleted = completedSteps.includes(index);
    const isCurrent = current === index;

    if (isCompleted) {
      return (
        <div
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            background: "#ECFDF3",
            borderColor: "#ABEFC6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CheckOutlined style={{ fontSize: "12px", color: "#079455" }} />
        </div>
      );
    }

    return (
      <div
        style={{
          width: "28px",
          height: "28px",
          borderRadius: "50%",
          background: isCurrent ? "#FDF4FF" : "#f0f0f0",
          color: isCurrent ? "#9F1AB1" : "#344054",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "14px",
        }}
      >
        {index + 1}
      </div>
    );
  };

  const stepItems = steps.map((step, index) => ({
    title: step.title,
    status: getStatus(index),
    icon: getIcon(index),
  }));

  return (
    <div
      style={{ width: "288px", padding: "20px 0" }}
      className="contract-form-container"
    >
      <Steps
        direction="vertical"
        current={current}
        style={{ height: "723px" }}
        items={stepItems}
      />
    </div>
  );
};

export default StepsComponent;
